import React from "react";
import { Route } from "react-router-dom";
import CallCenterGrading from "../pages/grading/callcenter_grading";
import RequireAuth from "../components/VersatileComponents/RequireAuth";

const GradingRoutes = () => [
  <Route
    key="callcenter-grading"
    path="/callcenter/grading"
    element={
      <RequireAuth>
        <CallCenterGrading />
      </RequireAuth>
    }
  />,
];

export default GradingRoutes;
